export default "__VITE_ASSET__7e7db0d7__"